module.exports = __webpack_public_path__ + "fonts/social.2451f89.woff";